<template>
    <div class="client">
        <div class="box-white-wrapper">
            <form-wizard ref="wizard" :color="color" title="" subtitle="" :startIndex="startIndex">
                <tab-content title="Datos básicos" :before-change="validateFirstStep">
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.client.customerType.$error }]" >
                            <label class="vs-input--label">Tipo Casillero</label>
                            <select-input :options="lockers" v-model="$v.client.customerType.$model"></select-input>
                            <span class="error-text" v-if="$v.client.customerType.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input',{'has-error': $v.client.dni.$error }]" >
                            <vs-input label="Cédula o pasaporte" v-model.trim="$v.client.dni.$model"/>
                            <span class="error-text" v-if="$v.client.dni.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.client.name.$error }]">
                            <vs-input label="Nombre" v-model.trim="$v.client.name.$model"/>
                            <span class="error-text" v-if="$v.client.name.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div class="form-input">
                            <vs-input label="Apellidos"  v-model.trim="client.lastName"/>
                            <!-- <span class="error-text" v-if="$v.client.lastName.$error"><feather type="info" />Este campo es requerido</span> -->
                        </div>
                    </div>
                    <div class="group">
                        <!-- <div :class="['form-input',{'has-error': $v.client.birthday.$error }]"> -->
                        <div class="form-input">
                            <label class="vs-input--label">Fecha Nacimiento</label>
                            <v-date-picker v-model="client.birthday" locale="es"></v-date-picker>
                            <!-- <span class="error-text" v-if="$v.client.birthday.$error"><feather type="info" />Este campo es requerido</span> -->
                        </div>
                        <div class="form-input">
                            <vs-input label="Profesión" v-model.trim="client.profession"/>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.client.mobile.$error }]" >
                            <vs-input label="Célular"  v-model.trim="$v.client.mobile.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.client.mobile.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div class="form-input">
                            <vs-input label="Teléfono" v-model.trim="client.phone" @keypress="isNumber($event)"/>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': !$v.client.email.email || $v.client.email.$error || checkMail }]" >
                            <vs-input label="Email"  v-model.trim="$v.client.email.$model" @change="existEmail"/>
                            <span class="error-text" v-if="!$v.client.email.email"><feather type="info" />E-mail invalido</span>
                            <span class="error-text" v-if="checkMail"><feather type="info" /> {{ errorExistMail}}</span>
                        </div>
                        <div :class="['form-input',{'has-error': $v.client.password.$error }]"  v-if="!isUpdating" >
                            <vs-input label="Contraseña"  v-model.trim="$v.client.password.$model"/>
                            <span class="error-text" v-if="$v.client.password.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div class="form-input" v-if="isUpdating">
                            <label class="vs-input--label">Estado</label>
                            <select-input :options="status" v-model="client.status"></select-input>
                        </div>
                       
                    </div> 
                </tab-content>
                <tab-content title="Datos de entrega">
                    <div class="wrap-info-delivery">
                        <div class="title"><h3>Zona geográfica</h3></div>
                        <div class="group">
                            <div :class="['form-input',{'has-error': $v.client.province.$error }]" >
                                <label class="vs-input--label">Provincia</label>
                                <select-input :options="provinces" v-model="$v.client.province.$model" @input="filterCanton"></select-input>
                            </div>
                            <div :class="['form-input',{'has-error': $v.client.canton.$error }]" >
                                <label class="vs-input--label">Cantón</label>
                                <select-input :options="tempCanton" v-model="$v.client.canton.$model" @input="filterDistricts"></select-input>
                            </div>
                            <div :class="['form-input',{'has-error': $v.client.district.$error }]" >
                                <label class="vs-input--label">Distrito</label>
                                <select-input :options="tempDistrict" v-model="$v.client.district.$model"></select-input>
                            </div>
                        </div>
                        <div class="group address">
                            <div :class="['form-input',{'has-error': $v.client.address.$error }]" >
                                <vs-input label="Dirección" v-model.trim="$v.client.address.$model"/>
                            </div>
                        </div>
                    </div>
                    <div class="group">
                        <div class="form-input">
                        <!-- <div :class="['form-input',{'has-error': $v.client.province.$error }]" > -->
                            <label class="vs-input--label">¿Dónde quieres recibir tu paquete?</label>
                            <select-input :options="deliveries" v-model="$v.client.delivery.$model"></select-input>
                        </div>
                    </div>                        
                    <div class="notifications">
                        <div class="title"><h3>Como te gustaría ser notificado?</h3></div>
                        <div class="group">
                        
                            <div class="form-input">
                                <div class="switch-group">
                                    <label for="">WhatsApp</label>
                                    <vs-switch color="success" v-model="client.whatsapp"/>
                                </div>
                                <div class="switch-group">
                                    <label for="">Llamada</label>
                                    <vs-switch color="success" v-model="client.byCall"/>
                                </div>
                                <div class="switch-group">
                                    <label for="">Correo</label>
                                    <vs-switch color="success" v-model="client.byMail"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab-content>

                    <template slot="footer" slot-scope="props">
                        <div class="wizard-footer-left">
                            <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" :style="props.fillButtonStyle">Atras</wizard-button>
                            <span @click="$router.go(-1)" class="back" v-if="props.activeTabIndex == 0">Regresar</span>
                        </div>
                        <div class="wizard-footer-right">
                            <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Siguiente</wizard-button>
                            <wizard-button v-else @click.native="handleCustomer" :disabled="confirmStatus || $v.$invalid" id="btnConfirm"
                                class="wizard-footer-right finish-button vs-con-loading__container" :style="props.fillButtonStyle">{{props.isLastStep ? finishButtonText : 'Siguiente'}}
                            </wizard-button>
                        </div>
                    </template>
            </form-wizard>
        </div>
    </div>
</template>
<script>
import ClientModel from '@/models/ClientModel';
import ClientDataService from "@/services/ClientDataService";
import UserDataService from "@/services/UserDataService";
import { required, email } from 'vuelidate/lib/validators'
import {helper} from '@/helpers/utils'
import SelectInput from '@/components/Form/Select-Input.vue'

export default {
  name: 'clientManage',
  mixins: [helper],
  components: {
    SelectInput
  },
    data() {
      return {
        color: '#1a426d',
        isUpdating: false,
        startIndex: 0,
        finishButtonText: 'Guardar',
        confirmStatus: false,
        client: new ClientModel(),
        deliveries: [],
        lockers: [],
        tempCanton:[],
        tempDistrict: [],
        provinces: [],
        cantons: [],
        districts: [],
        checkMail: false,
        errorExistMail: '',
        status: [
          {
            id: 1,
            name: "Activo"
          },
          {
            id: 0,
            name: "Inactivo"
          },
        ],
      }
    },
    validations: {
        client:{
            customerType: { required },
            dni: { required },
            name: { required },
            // lastName : { required },
            email : { required, email,},
            password : { required },
            mobile : { required },
            // birthday : { required },
            province : { required },
            canton : { required },
            district : { required },
            address : { required },
            delivery : { required },
        },
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveLocations()
      this.retrieveCustomerTypes()
      this.retrieveLocationsDelivery();
      if(this.$route.params.id !== undefined){
        this.retrieveCustomer(this.$route.params.id)
      }
    },
    methods:{
        existEmail(){
            this.$v.client.email.$touch()
            console.log('EMAIL ', this.$v.client.email.$invalid)
            if(!this.$v.client.email.$invalid){
                UserDataService.validEmail({email: this.client.email})
                .then(() => {
                    this.checkMail = true
                    this.errorExistMail = 'El email '+ this.client.email+" ya esta registrado."
                    this.client.email   = ""
                })
                .catch(e => {
                    if(e.response.status == 404){
                      this.checkMail = false
                    }else{
                      this.$vs.notify({title:'Información!',text:'Error validando el email',color:'danger',icon:'error_outline'})     
                    }     
                });
            }
        },
        validateFirstStep(){
            return new Promise((resolve, reject) => {
                console.log(resolve, reject);
                this.$v.client.customerType.$touch();   this.$v.client.dni.$touch();
                this.$v.client.name.$touch();     
                // this.$v.client.lastName.$touch();
                // this.$v.client.birthday.$touch(); 
                this.$v.client.mobile.$touch();   this.$v.client.email.$touch();   
                this.$v.client.password.$touch();


                if (!this.$v.client.customerType.$invalid && !this.$v.client.dni.$invalid &&
                    !this.$v.client.name.$invalid && !this.$v.client.mobile.$invalid &&
                    !this.$v.client.email.$invalid && !this.$v.client.password.$invalid) {

                // if (!this.$v.client.customerType.$invalid && !this.$v.client.dni.$invalid &&
                //     !this.$v.client.name.$invalid && !this.$v.client.lastName.$invalid &&
                //     !this.$v.client.birthday.$invalid && !this.$v.client.mobile.$invalid &&
                //     !this.$v.client.email.$invalid && !this.$v.client.password.$invalid) {
                    resolve(true);

                }else{
                    console.log('NO')
                    resolve(false);
                }
                // resolve(true);
            
           })
            
        },
        filterCanton(value){
            console.log(value);
            this.client.province = value
            this.client.canton   = { code: "0", name: ''}
            this.tempCanton      = []
            this.client.district = { code: "0", name: ''}
            this.tempDistrict    = []
            this.tempCanton = this.cantons.filter((item) => {
                return value.code == item.pv01Code
            })
            console.log('TEST');
        },
        filterDistricts(value){
            console.log(value);
            this.client.canton   = value
            this.tempDistrict    = []
            this.client.district = { code: "0", name: ''}
            this.tempDistrict = this.districts.filter((item) => {                
                return value.code == item.ct01Code
            })
            console.log('TEST');
        },
        handleCustomer(){
           this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.createCustomer()
            } else {
                this.updateCustomer()
            }
        },
        createCustomer(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            that.client.byMail   = that.client.byMail == true ? 1 : 0
            that.client.byCall   = that.client.byCall == true ? 1 : 0
            that.client.whatsapp = that.client.whatsapp == true ? 1 : 0
            ClientDataService.create(that.client)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'El cliente fue creado exitosamente!',color: 'success',icon:'check'})
                that.client    = new ClientModel()
                this.$v.$reset()
                this.$refs.wizard.reset();
                // this.retrieveUsers()
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error creando el cliente',color:'danger',icon:'error_outline'})                
            });

        },
        updateCustomer(){
            const that = this
            that.loadingProgress ('#btnConfirm','#1a426d')
            that.confirmStatus = true
            that.client.byMail   = that.client.byMail == true ? 1 : 0
            that.client.byCall   = that.client.byCall == true ? 1 : 0
            that.client.whatsapp = that.client.whatsapp == true ? 1 : 0
            ClientDataService.update(that.client)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.$vs.notify({title:'Información!',text:'El cliente fue actualizado exitosamente!',color: 'success',icon:'check'})
                //this.$refs.wizard.reset();
                this.$router.push({ name: "Customer", params:{ id: this.client.id }})
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                 if(e.response.status == 400){
                    this.$vs.notify({title:'Error!',text:'El email ingresado ya se encuentra en el sistema.',color:'danger',icon:'error_outline'})
                }else{
                   that.$vs.notify({title:'Información!',text:'Error actualizando el cliente',color:'danger',icon:'error_outline'})                
                }
            });

        },
        retrieveCustomer(id) {
            ClientDataService.getCustomer(id)
            .then(response => {
                
                let _objCustomer = response.data.customer;
                let _objProvince = { code: _objCustomer.pvcode, name: _objCustomer.pvname}
                let _objCanton   = { code: _objCustomer.ctcode, name: _objCustomer.ctname}
                let _objDistrict = { code: _objCustomer.dtcode, name: _objCustomer.dtname}
                this.filterCanton(_objProvince)
                this.filterDistricts(_objCanton)
                this.client = new ClientModel(
                    _objCustomer.id,
                    { id: _objCustomer.typecode, name: _objCustomer.typename},
                    _objCustomer.identification,
                    _objCustomer.firstName,
                    _objCustomer.lastName,
                    _objCustomer.email,
                    _objCustomer.password,
                    _objCustomer.phone,
                    _objCustomer.mobile,
                    new Date(_objCustomer.birthdate),
                    _objCustomer.profession,
                    '',
                    _objProvince,
                    _objCanton,
                    _objDistrict,
                    _objCustomer.address,
                    { id: _objCustomer.dlvCode, name: _objCustomer.dlvName},
                    _objCustomer.whatsapp == '1' ? true : false,
                    _objCustomer.bymail == '1' ? true : false,
                    _objCustomer.bycall == '1' ? true : false,
                    _objCustomer.profileUrl,
                    { id: _objCustomer.statuscode, name: helper.filters.capitalize(_objCustomer.statusname) }
                )
                this.isUpdating = true;
                this.finishButtonText = 'Actualizar'
                this.client.password = '123';
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                if(e.response.status == 404){
                    this.$router.push({ name: "Home"})
                    this.$vs.notify({title:'Error!',text:'El cliente no fue encontrado.',color:'danger',icon:'error_outline'})
                }else{
                    this.$router.push({ name: "Home"})
                    this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del cliente!',color:'danger',icon:'error_outline'})
                }
            });
        },    
        retrieveLocations() {
            ClientDataService.getLocationAddress()
            .then(response => {
                this.provinces = response.data.provinces;
                this.cantons   = response.data.cantons;
                this.districts = response.data.districts;
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo las provincias!',color:'danger',icon:'error_outline'})
            });
        },    
        retrieveLocationsDelivery() {
            ClientDataService.getLocationsDelivery()
            .then(response => {
                this.deliveries = response.data
                this.deliveries.push({
                    code: 4, 
                    name: 'No Aplica'
                })
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo los lugares de entrega!',color:'danger',icon:'error_outline'})
            });
        },
        retrieveCustomerTypes() {
            ClientDataService.getCustomerTypes()
            .then(response => {
                this.lockers = response.data;
                this.client.customerType = this.lockers[0]
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo las tipos de clientes!',color:'danger',icon:'error_outline'})
            });
        },
        
        isLastStep() {
            if (this.$refs.wizard) {

                return this.$refs.wizard.isLastStep
            }
            return false
        }
    
        
    }
}
</script>
